import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router';

import general from './general.js';
import invite from './invite.js';
import notifications from './notifications.js';
import registration from './registration.js';
import translations from './translations.js';
import bundles from './bundles.js';

export default (history) => combineReducers({
    bundles,
    form: formReducer,
    general,
    invite,
    notifications,
    registration,
    router: connectRouter(history),
    translations,
});
